<nb-layout>
  <nb-layout-column>
    <div *ngIf="responsiveMode === 'lg'" class="d-flex flex-column align-items-center justify-content-center position-relative">
      <div class="m-auto py-5">
        <img src="assets/images/errors/error-404.png" alt="">
        <div class="d-flex flex-column align-items-center justify-content-between text-position">
          <p class="main-text">صفحه‌ی مورد نظر پیدا نشد.</p>
          <p class="description">صفحه‌ای که می‌خواهید در وبسایت تارت به آن دسترسی پیدا کنید در سرور یافت نشده است. لطفا مجدد تلاش کنید.</p>
          <div class="button-action">
            <button nbButton (click)="pageBack()">بازگشت</button>
          </div>
        </div>
      </div>
    </div>

    <div *ngIf="responsiveMode === 'md'" class="m-auto ">
      <img src="assets/images/errors/error-404.png" alt="">
      <div class="d-flex flex-column align-items-center justify-content-between">
        <p class="main-text">صفحه‌ی مورد نظر پیدا نشد.</p>
        <p class="description">صفحه‌ای که می‌خواهید در وبسایت تارت به آن دسترسی پیدا کنید در سرور یافت نشده است. لطفا
          مجدد تلاش کنید.</p>
        <div class="button-action">
          <button nbButton (click)="pageBack()">بازگشت</button>
        </div>
      </div>
    </div>
  </nb-layout-column>
</nb-layout>
